// ** Icons Import
import {
  FileText,
  Circle,
  Shield,
  Navigation2,
  DollarSign,
  Users
} from 'react-feather'

export default [
  {
    header: 'Administrador',
    action: 'concesion-level-1',
    resource: 'parkingMeterSystem'
    // action: 'concession-level-2',
    // resource: 'parking'
  },
  {
    id: 'Tickets',
    title: 'Admin',
    action: 'concesion-level-1',
    resource: 'parkingMeterSystem',
    // action: 'concession-level-2',
    // resource: 'parking',
    icon: <FileText size={20} />,
    children: [
      {
        id: 'Areas',
        title: 'Areas',
        action: 'concesion-level-1',
        resource: 'parkingMeterSystem',
        // action: 'concession-level-2',
        // resource: 'parking',
        icon: <Circle size={12} />,
        navLink: '/parking/area'
      },
      {
        id: 'Zonas',
        title: 'Zonas',
        action: 'concesion-level-1',
        resource: 'parkingMeterSystem',
        // action: 'concession-level-2',
        // resource: 'parking',
        icon: <Circle size={12} />,
        navLink: '/parking/zones'
      },
      {
        id: 'Subzonas',
        title: 'Subzonas',
        action: 'concesion-level-1',
        resource: 'parkingMeterSystem',
        // action: 'concession-level-2',
        // resource: 'parking',
        icon: <Circle size={12} />,
        navLink: '/parking/subzone'
      }
    ]
  },
  {
    header: 'Historial',
    action: 'concesion-level-1',
    resource: 'parkingMeterSystem'
    // action: 'concession-level-2',
    // resource: 'parking'
  },
  {
    id: 'Parking',
    title: 'Parquimetros',
    action: 'concesion-level-1',
    resource: 'parkingMeterSystem',
    // action: 'concession-level-2',
    // resource: 'parking'
    icon: <FileText size={20} />,
    children: [
      {
        id: 'History',
        title: 'Historial',
        action: 'concesion-level-1',
        resource: 'parkingMeterSystem',
        // action: 'concession-level-2',
        // resource: 'parking',
        icon: <Circle size={12} />,
        navLink: '/parking/list'
      }
    ]
  }
]
